export default __webpack_public_path__ + "static/media/TDPS_PORTAL_WireTemplateUpload.9adf5e90.xlsx";